import { prodModUserIds, stagingModUserIds } from '../consts/modUserIds'
import { environment } from '../consts/environment'
import murmurhash from 'murmurhash'
import { IUser } from '@/interfaces/user'
import { User } from '@sentry/nextjs'
import { ProfileRecommendation } from 'containers/recommendations/types/recommendations'

/**
 * Checks if user ID is a mod
 * @param userId - ID string
 * @returns boolean
 */
export const isModUserId = (userId: string) => {
  const IS_PROD = environment.env === 'production'

  if (IS_PROD) {
    return prodModUserIds.includes(userId)
  }

  return stagingModUserIds.includes(userId)
}

/**
 * Converts alphanumeric user ID to a numeric value
 * @param userId - ID string
 * @returns number
 */
export const getNumericValueForUserId = (userId: string) => {
  // Converts alphanumeric user ID to a numeric value
  return murmurhash.v3(userId)
}

/**
 * Return's a percentage value for a user ID between 0 and 99 to help with feature rollouts
 * @param userId - ID string
 * @returns number
 */
export const getPercentageValueForUserId = (userId: string) => {
  const numericUserId = getNumericValueForUserId(userId)

  // value between 0 and 99
  return numericUserId % 100
}

/**
 * Returns the user's full name
 * @param user - UserDto
 * @returns - string with the full name
 */
export const userFullName = (
  user: IUser | User | ProfileRecommendation
): string => {
  switch (true) {
    case Boolean(user?.firstName && user?.lastName):
      return `${user.firstName} ${user.lastName}`
    case Boolean(user?.firstName):
      return user.firstName
    case Boolean(user?.lastName):
      return user.lastName
    default:
      return ''
  }
}
